export default __webpack_public_path__ + "2947c03af41bcca9a44ea85d64395efb.png";